














































































import BankImg from '@/components/image/BankImg.vue'
import InstitutionImg from '@/components/image/InstitutionImg.vue'
import ListItem from '@/components/list/ListItem.vue'
import TypeSelectionPopup from '@/components/popup/btt/TypeSelection.vue'
import BankCodeSelectionPopup from '@/components/popup/btt/BankCodeSelection.vue'
import FooterLayout from '@/components/Footer.vue'
import HeaderLayout from '@/components/Header.vue'
import MainLayout from '@/layouts/default/MainLayout.vue'
import Translation from '@/mixins/Translation'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import {TranslateResult} from 'vue-i18n'
import toTextClClass from '@/filters/to-text-cl-class'
import toCertStatusTextColor from '@/filters/to-cert-status-text-color'
import {Link} from 'element-ui'
import {namespace} from 'vuex-class'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import PopupHandlerMixin from '@/mixins/popupHandler'
import BankEnablingPopups from '@/components/popup/BankEnablingPopups.vue'
import WorkflowHandler from '@/components/WorkflowHandler.vue'
import IndividualBizBankInfo from '@/components/popup/btt/IndividualBizBankInfo.vue'
import FooterButton from '@/components/FooterButton.vue'

const institutions = namespace('institutions')
const layout = namespace('layout')
const biz = namespace('biz')
const gtm = namespace('gtm')

interface Item {
  title: string | TranslateResult
  status: string,
  id: string | null
  type: string
  name: string
  bankCode: string
}
/**
 * @displayName CertCenterPage
 */
@Component({
  components: {
    FooterButton,
    MainLayout,
    WorkflowHandler,
    BankEnablingPopups,
    TypeSelectionPopup,
    BankCodeSelectionPopup,
    InstitutionImg,
    BankImg,
    FooterLayout,
    ListItem,
    HeaderLayout,
    [Link.name]: Link,
    IndividualBizBankInfo,
  },
})
export default
class CertCenterPage extends Mixins(Translation, PopupHandlerMixin) {
  @Prop({default: 0, type: Number}) windowScrollY: number

  @institutions.State('institutions') institutions
  @institutions.Action('getCertInstitutions') getCertInstitutions
  @layout.Mutation('updateError') updateError
  @biz.State('isCorporate') isCorporate
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  loading: boolean = true
  serviceName: string = ''
  dialogOpen: boolean = false

  isBankNotExists(institutionList) {
    return institutionList.filter((institution) => institution.type === 'bank').length == 0
  }

  isEmployeeInsuranceNotExists(institutionList) {
    return institutionList.filter((institution) => institution.type === 'ei').length == 0
  }

  isHometaxPopbillBothPending(institutionList) {
    return institutionList
    .filter((institution) =>
      (institution.type === 'hometax' && institution.status === 'pending')
      || (institution.type === 'popbill' && institution.status === 'pending'))
    .length == 2
  }

  removePopbill(institutionList) {
    return institutionList.filter((institution) => institution.type !== 'popbill')
  }

  renameHometaxSubTitle(institutionList) {
    return institutionList.map((institution) => {
          if(institution.type === 'hometax') return {...institution, sub: this.ts('institution.type.hometax-popbill')}
          return institution
      })
  }

  get list(): Item[] {
    let institutionList = JSON.parse(JSON.stringify(this.institutions))
    if(this.isBankNotExists(institutionList)) {
      institutionList.push({id: null, status: 'pending', type: 'bank', name: 'bank', title: this.ts('bank')})
    }
    if(this.isHometaxPopbillBothPending(institutionList)) {
      institutionList = this.renameHometaxSubTitle(this.removePopbill(institutionList))
    }
    if(this.isEmployeeInsuranceNotExists(institutionList)) {
      institutionList.push({id: null, status: 'pending', type: 'ei', name: 'ei', title: this.ts('ei')})
    }
    institutionList = institutionList.map((institution) => ({
      title: this.toInstitutionName(institution),
      sub: this.toFeatureName(institution),
      ...institution,
    }))
    return institutionList.filter((institution) => institution.type !== 'popbill' && institution.type !== 'bank')
  }

  get addTypes() {
    return [{title: `${this.ts('certificate')} 보기`, value: 'cert'}]
  }

  get createBankLinkText(): string {
    return `이용 중인 ${this.ts('bank')}이 목록에 없나요?`
  }

  mounted() {
    this.loadInstitutions()
    const popupName = this.$route.query.openPopupName
    if(popupName) {
      setTimeout(() => {
        this.openPopup(`${popupName}`)
      },500)
    }
  }

  loadInstitutions() {
    this.getCertInstitutions()
      .then(() => {this.loading = false})
      .catch((error) => {
        this.updateError({
          id: 'get-institutions',
          message: `${this.ts('enabling')}된 기관 목록을 불러오는데 실패하였습니다.`,
        })
        throw error
      })
  }

  toTextClClass(status) {
    return toTextClClass(toCertStatusTextColor(status))
  }

  toInstitutionName(institution) {
    const institutionNameArray = [this.ts(`institution.${institution.name}`)]
    if(institution.type === 'bank') {
      institutionNameArray.push(this.ts('bank'))
    }
    return institutionNameArray.join('')
  }

  toFeatureName(institution) {
    const featureNameArray = [this.ts(`institution.type.${institution.type}`)]
    return featureNameArray.join('')
  }

  onClickBackward() {
    const routeFrom = this.$route.query.callerPath
    if(routeFrom) {
      return this.$router
        .push({path: `${routeFrom}`})
        .catch((err) => err)
    }
    return this.$router
      .push({name: 'setting'})
      .catch((err) => err)
  }

  onClickEdit() {
    this.openPopup('certType')
  }

  onOpenRegisterPopup(item) {
    if(!item.name) {
      this.serviceName = ''
    } else {
      this.serviceName = item.name
    }
    this.openPopup('certRegister')
  }

  onClickLink() {
    this.logEventWithGroups({
      eventType: 'click',
      eventProperties: {
        'target': 'link_bank_invisible',
        'page_name': 'cert_center',
      }
    })
    if(this.isCorporate) {
      this.openPopup('bankEnabling')
    } else {
      this.openPopup('individualBizBankInfo')
    }
  }

  onSelectType() {
    return this.$router
      .push({name: 'certificates'})
      .catch((err) => err)
  }

  onCloseCert() {
    this.closePopup('certRegister')
    this.loadInstitutions()
  }

  onClickStatus(item) {
    const {name, status, type, bankCode} = item
    switch(status) {
      case 'success':
        // eslint-disable-next-line no-case-declarations
        return this.$router
          .push({name: 'cert-success-lists', params: {name, type, bankCode}})
          .catch((err) => err)
      case 'failure':
      case 'expired':
        return this.$router
          .push({name: 'cert-failed-reason', params: {name, type}})
          .catch((err) => err)
      case 'pending':
        if(name === 'bank') return this.openPopup('bankEnabling')
        return this.onOpenRegisterPopup(item)
      // no default
    }
  }
}
